module.exports = __webpack_public_path__ + "img/P14-en.2b784ccc.png";